import type { MarketOrder } from '../model'
import type { TransKey } from '@root/shared/localization'

export * as OrderUiUtil from './order-ui-util'

export const SWAP_ORDER_STATUS_LABEL_MAP: Record<MarketOrder.Status, TransKey> =
  {
    active: 'order.status.active',
    failed: 'order.status.failed',
    finished: 'limit_order.status_completed',
  }
